import apiClient from '@u/apiClient'
import RegisterCompanyToPeppolController from '@/wayfinder/actions/App/Http/Controllers/Digiteal/RegisterCompanyToPeppolController'
import CheckCompanyToPeppolController from '@/wayfinder/actions/App/Http/Controllers/Digiteal/CheckCompanyToPeppolController'
import PeppolCheckInvoiceable from '@/wayfinder/actions/App/Http/Controllers/Partners/PeppolCheckInvoiceable'
import PeppolSendInvoice from '@/wayfinder/actions/App/Http/Controllers/Invoice/PeppolSendInvoice'

export default {
  registerCompanyToPeppol({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RegisterCompanyToPeppolController.post({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkCompanyReady({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CheckCompanyToPeppolController.get({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkPeppolInvoiceable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(PeppolCheckInvoiceable.post(), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendInvoiceViaPeppol({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(PeppolSendInvoice.post({ invoice: payload.id }), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
